"use strict";

var organizations = require("app/util/api/organizations");
var people = require("app/util/api/people");
var deals = require("app/util/api/deals");

var resources = {
  empresa: organizations,
  pessoa: people,
  negocio: deals
};

module.exports = function(type) {
  var resource = resources[type];
  if (resource == null) {
    throw new Error("Invalid resource type: " + type);
  }
  return resources[type];
};



// WEBPACK FOOTER //
// ./app/util/api/factory.js